import Enum from "./Enum";

export default Enum.create( {
	COACHING: "COACHING",
	VISION: "VISION",
	COMMUNICATION: "COMMUNICATION",
	DEVELOPMENT: "DEVELOPMENT",
	RESPECT: "RESPECT",
	DELEGATION: "DELEGATION",
	DECISIONS: "DECISIONS",
	CONFLICT: "CONFLICT",
	OTHER: "OTHER",
} );
